import React, { useState } from 'react';
import './Home.css';
import LogoImg from '../../assets/images/logo.svg';
import DutaLogo from '../../assets/images/pt_duta_logo.png';
import HistoryImg from '../../assets/images/history.svg';
import DocumentImg from '../../assets/images/documents.svg';
import ScheduleImg from '../../assets/images/schedules.svg';
import RequestImg from '../../assets/images/request.svg';
import PersonIcon from '../../assets/images/person.svg'; 
import ProfileIcon from '../../assets/images/profile.svg'; 
import LogoutIcon from '../../assets/images/logout.svg'; 
import { logoutPost } from '../../Api';

function Home() {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const handleLogout = async () => {
    try {
      console.log("Token before logout:", localStorage.getItem('token'));
      await logoutPost();
      localStorage.clear();
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="homepage">
      <div className="header">
        <div className="logo-container">
        <div className="logo_wrap"><img style={{ height: '75px' }} src={LogoImg} alt="Jasa Indonesia Perdana Logo" />
        <img style={{ height: '67px' }}  src={DutaLogo} alt="Duta Indonesia Perdana Logo" className="dutalogo" /></div>
          
        </div>
        <div className="user-menu">
          <div
            className="user-icon"
            onClick={() => setDropdownVisible(!isDropdownVisible)}
          >
            <img src={PersonIcon} alt="Person Icon" />
          </div>
          {isDropdownVisible && (
            <div className="dropdown-menu">
              <a href="/profil">
                <div className="dropdown-item">
                  <span>Your Profile</span> <img src={ProfileIcon} alt="" />
                </div>
              </a>
              <div className="dropdown-item" onClick={handleLogout}>
                <span>Logout</span>  <img src={LogoutIcon} alt="" />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="button-grid">
        <a href="/history">
          <div className="button history">
            <img src={HistoryImg} alt="" />
            <span>Histori Servis AC</span>
          </div>
        </a>
        <a href="/document">
          <div className="button documents">
            <img src={DocumentImg} alt="" />
            <span>Lampiran Servis AC</span>
          </div>
        </a>
        <a href="/schedules">
          <div className="button schedules">
            <img src={ScheduleImg} alt="" />
            <span>Jadwal Servis AC</span>
          </div>
        </a>
        <a href="/request">
          <div className="button request">
            <img src={RequestImg} alt="" />
            <span>Pengajuan Servis AC</span>
          </div>
        </a>
        <a href="/proses-pengerjaan">
          <div className="button request">
            <img src={RequestImg} alt="" />
            <span>Proses Pengerjaan</span>
          </div>
        </a>
      </div>
    </div>
  );
}

export default Home;
